import { BookingType, JourneyType, TravelService } from './Common/JyrneyEnums'
import { Location } from './Common/Location'
import { Passenger } from './Common/Passenger'
import { BookingBookingReference } from './Quote.type'

export interface Price {
  total: number
  price: number
  vat: number
  currency: string
}

export interface BookedService {
  serviceTypeName: TravelService
  quantity?: number
}

export interface BookedVehicle {
  bookedVehicleId: number
  jobReference: string
  supplierId: number
  supplierName: string
  vehicleTypeName: string
  estimatedPrice: Price
  actualPrice?: Price
  services?: Array<BookedService>
  supplierReference?: string
  bookingSupplierStatusTypeName: string
  lastUpdated: Date
  lastUpdatedBy: string
}

export type Booking = {
  id: number
  parentBookingId?: number
  bookingReference: string
  journeyReference: string
  bookingTypeName: BookingType
  clientId: number
  bookerId: number
  onBehalfOf?: number
  numberOfPassengers: number
  passengers: Array<Passenger>
  journeyTypeName: JourneyType
  isImmediateJourney: boolean
  waitBeforeReturnTime?: number
  when: Date
  timeZone: string
  pickup: Location
  dropOff: Location
  additionalStops: Array<Location>
  specialInstructions: string
  estimatedJourneyDistance: number
  estimatedJourneyTime: number
  vehicles: Array<BookedVehicle>
  bookingReferenceValues: Array<BookingBookingReference>
  bookingStatusTypeName: string
  lastUpdated: Date
  lastUpdatedBy: string
}

export enum BookingSupplierStatus {
  Allocated = 'Allocated',
  Declined = 'Declined',
  Confirmed = 'Confirmed',
  Cancelled = 'Cancelled',
  OnRoute = 'On Route',
  Arrived = 'Arrived',
  Passenger_Picked_Up = 'Passenger On Board',
  Passenger_Dropped_Off = 'Passenger Dropped Off',
  OnRoute_Passenger_On_Board = 'On Route',
  Completed = 'Completed',
  Supplier_Cancelled = 'Supplier Cancelled',
  No_Show = 'No Show',
  Driver_Location_Update = 'Driver Location Update',
  Driver_Allocated = 'Driver Allocated',
  Manual_Reallocation_Pending = 'Manual Reallocation Pending',
  Manual_Intervention_Required = 'Manual Intervention',
  Booking_Update_Pending = 'Update Pending',
  Primary_Reallocation_Pending = 'Primary Reallocation Pending',
  Completed_Pending_Invoice = 'Completed Pending Invoice',
  Pickup_Location_Update = 'Pickup Location Update',
}
